import { apiClient } from "@/lib/api-client";
import type {
  CreateLinkRequest,
  CreateLinkResponse,
  LinkDetail,
  ListLinksParams,
  ListLinksResponse,
  UpdateLinkRequest,
} from "./types";

export const linksApi = {
  list: (params: ListLinksParams = {}) => {
    const searchParams = new URLSearchParams();
    if (params.page) searchParams.set("page", String(params.page));
    if (params.pageSize) searchParams.set("pageSize", String(params.pageSize));
    if (params.linkType) searchParams.set("linkType", params.linkType);
    if (params.status) searchParams.set("status", params.status);
    if (params.customerId) searchParams.set("customerId", params.customerId);
    if (params.paginationToken) searchParams.set("paginationToken", params.paginationToken);
    const qs = searchParams.toString();
    return apiClient.get<ListLinksResponse>(`/v1/links${qs ? `?${qs}` : ""}`);
  },

  get: (shortCode: string) =>
    apiClient.get<LinkDetail>(`/v1/links/${shortCode}`),

  create: (data: CreateLinkRequest) =>
    apiClient.post<CreateLinkResponse>("/v1/links", data),

  update: (shortCode: string, data: UpdateLinkRequest) =>
    apiClient.patch<LinkDetail>(`/v1/links/${shortCode}`, data),

  delete: (shortCode: string) =>
    apiClient.delete<void>(`/v1/links/${shortCode}`),
};
